import { isTimePast } from '@akin-home/dates';
import {
  StateVariable,
  findBooleanStateVariableByName,
  findNumberStateVariableByName,
  findTextStateVariableByName,
} from '@akin-home/state-variables';
import { useGetStateVariable } from '../../state_variables';
import { useListStateVariables } from '../../state_variables/hooks/useListStateVariables';

export const useBMCDailyReminderState = () => {
  const { data: is_bmc_participant_data } = useGetStateVariable(
    'User_is_BMC_participant',
    {
      // Check if the user is a bmc participant every hour
      refetchInterval: 1000 * 60 * 60,
    }
  );

  const is_bmc_participant = is_bmc_participant_data?.value === true;

  const { data, refetch } = useListStateVariables(
    ['BMC_daily_survey_skipped', 'Daily_survey_status', 'BMC_survey_reminder'],
    {
      /** Only fetch the rest of the state variables if the user is a bmc participant */
      enabled: is_bmc_participant,
      // Check if user should be notified every 10 minutes
      refetchInterval: 1000 * 10,
    }
  );

  const should_show_reminder =
    !!is_bmc_participant && checkShouldShowReminder(data);

  return {
    refetch,
    should_show_reminder,
  };
};

function checkShouldShowReminder(variables?: StateVariable[]) {
  if (!variables) {
    return false;
  }

  /** Check if user has skipped the survey */
  const skipped = !!findBooleanStateVariableByName(
    variables,
    'BMC_daily_survey_skipped'
  )?.value;

  // Check the status. 0 means they haven't started it.
  const status =
    findNumberStateVariableByName(variables, 'Daily_survey_status')?.value || 0;

  const hasnt_started_survey = !skipped && status === 0;

  // They've already started the survey, don't show the reminder
  if (!hasnt_started_survey) {
    return false;
  }

  // Get the specified reminder time, or default to 15:00
  const reminder_time =
    findTextStateVariableByName(variables, 'BMC_survey_reminder')?.value ||
    '15:00';

  // Check if the time is past
  return isTimePast(reminder_time);
}
